export enum CodeFormatBirthDate {
  Completa = '1',
  SenzaGiorno = '2',
  SenzaGiornoMese = '3',
  SoloAnni = '4',
}

export const valueCompleta = 'Completa';
